var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative" },
    [
      _c("UiInput", {
        attrs: { type: _vm.showPassword ? "text" : "password" },
        on: { input: _vm.onInput },
        model: {
          value: _vm.currentValue,
          callback: function ($$v) {
            _vm.currentValue = $$v
          },
          expression: "currentValue",
        },
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "position-absolute top-0 right-0 fa ",
        class: _vm.showPassword ? "fa-eye-slash" : "fa-eye",
        on: {
          click: function ($event) {
            _vm.showPassword = !_vm.showPassword
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }